import { authAxiosClient } from '@/lib';

export const resendOtp = async ({ preAuthToken }: { preAuthToken: string }) => {
  return authAxiosClient.post('/auth/resend-otp', { preAuthToken });
};